import { Component } from '@angular/core';

@Component({
  selector: 'app-payment-panel-adyen-cb-skeleton',
  templateUrl: './payment-panel-adyen-cb-skeleton.component.html',
  standalone: false,
})
export class PaymentPanelAdyenCbSkeletonComponent {}
